import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {ExchangeService} from '../../services/exchange.service';
import {Router} from '@angular/router';
import {Exchange} from '../../models/exchange';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {BaseClientComponent} from '../../../components/base-client.component';

@Component({
  selector: 'app-list-exchanges',
  templateUrl: './list-exchanges.component.html',
  styleUrls: ['./list-exchanges.component.scss'],
  host: {class: 'sym-page'}
})
export class ListExchangesComponent extends BaseClientComponent implements OnInit {

  exchangesList: Exchange[];
  cols = [
    {field: 'name', header: 'Exchange', type: 'string', sortable: true, width: '130px'},
    {field: 'code', header: 'Portal exchange code', type: 'string', sortable: false, width: '90px'},
    {field: 'exchangeNameInTitle', header: 'Exchange name in title', type: 'string', sortable: false, width: '140px'},
    {field: 'fromSentDay', header: 'Form sent day', type: 'string', sortable: false, width: '80px'},
    {field: 'secondReminderDay', header: 'Second reminder day', sortable: false, type: 'date', width: '90px'},
    {field: 'thirdReminderDay', header: 'Third reminder day', sortable: false, type: 'date', width: '90px'},
    {field: 'quincyCutoffStartDay', header: 'Quincy cutoff start day', type: 'string', sortable: false, width: '90px'},
    {field: 'quincyCutoffPeriod', header: 'Quincy cutoff period', type: 'string', sortable: false, width: '90px'},
    {field: 'canAutoReport', header: 'Can AutoReport', type: 'string', sortable: false, width: '90px'},
    {field: 'canExempt', header: 'Can Exempt', type: 'string', sortable: false, width: '80px'},
    {field: 'canCarryForward', header: 'Can CarryForward', type: 'string', sortable: false, width: '100px'},
    {field: 'reportType', header: 'Report Type', type: 'string', sortable: false, width: '90px'},
    {field: 'jumpCheckThreshold', header: 'Jump check threshold', type: 'string', sortable: false, width: '90px'},
    {field: 'active', header: 'Active', type: 'string', sortable: false, width: '80px'},
    {field: 'note', header: 'Note', type: 'string', sortable: false, width: '140px'},
  ];

  constructor(private utilsService: UtilsService,
              private exchangeService: ExchangeService,
              private router: Router,
              private authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getExchangesList();
    });
    this.subscriptions.push(response$);
  }

  private getExchangesList() {
    this.utilsService.lockUi();
    this.exchangeService.getExchanges().subscribe({
        next: exchanges => {
          this.exchangesList = exchanges.sort((a, b) => a.name > b.name ? 1 : -1);
          this.utilsService.unlockUi();
        },
        error: () => {
          this.router.navigate(['/404']);
        }
      }
    );
  }

  getDadConfigCrudLink(exchange) {
    if (!exchange) {
      return;
    }
    const isSuper = this.authenticationService.userCurrent.roles.includes('ROLE_MCKAY_SUPER');
    const isAdmin = this.authenticationService.userCurrent.roles.includes('ROLE_MCKAY_ADMIN');
    if (isSuper) {
      if (!exchange.dadConfig) {
        return '/dad-config/new/' + exchange.name;
      } else {
        return '/dad-config/edit/' + exchange.dadConfig.name;
      }
    }
    if (isAdmin) {
      if (!exchange.dadConfig) {
        return './';
      } else {
        return '/dad-config/show/' + exchange.dadConfig.name;
      }
    }
    return './';
  }

}
